export default __webpack_public_path__ + "static/media/8.1.a875ee5b.mp4";